(() => {
  const instances = new WeakMap();

  class VeiledHeroSlider {
    constructor(section) {
      this.section = section;
      this.slides = Array.from(section.querySelectorAll('[data-veiled-hero-slide]'));
      this.dots = Array.from(section.querySelectorAll('[data-veiled-hero-dot]'));
      this.activeIndex = 0;
      this.timer = null;
      this.autoplay = section.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(section.dataset.autoplaySpeed) || 5600;
      this.pauseOnHover = section.dataset.pauseOnHover === 'true';
      this.keyboard = section.dataset.keyboard === 'true';

      this.onDotClick = this.onDotClick.bind(this);
      this.onMouseEnter = this.stop.bind(this);
      this.onMouseLeave = this.start.bind(this);
      this.onFocusIn = this.stop.bind(this);
      this.onFocusOut = this.start.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.init();
    }

    init() {
      if (!this.slides.length) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', this.onDotClick);
      });

      if (this.pauseOnHover) {
        this.section.addEventListener('mouseenter', this.onMouseEnter);
        this.section.addEventListener('mouseleave', this.onMouseLeave);
        this.section.addEventListener('focusin', this.onFocusIn);
        this.section.addEventListener('focusout', this.onFocusOut);
      }

      if (this.keyboard) {
        this.section.addEventListener('keydown', this.onKeyDown);
      }

      this.show(0);
      this.start();
    }

    onDotClick(event) {
      const nextIndex = Number(event.currentTarget.dataset.slideIndex);
      this.show(nextIndex);
      this.restart();
    }

    onKeyDown(event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.show(this.activeIndex + 1);
        this.restart();
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.show(this.activeIndex - 1);
        this.restart();
      }
    }

    show(index) {
      if (!this.slides.length) return;

      const total = this.slides.length;
      this.activeIndex = ((index % total) + total) % total;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    showBlock(blockId) {
      const blockSlide = this.slides.find((slide) => slide.dataset.blockId === blockId);
      if (!blockSlide) return;

      const index = this.slides.indexOf(blockSlide);
      this.show(index);
      this.stop();
    }

    start() {
      if (!this.autoplay || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.activeIndex + 1), this.autoplaySpeed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }

    destroy() {
      this.stop();

      this.dots.forEach((dot) => {
        dot.removeEventListener('click', this.onDotClick);
      });

      this.section.removeEventListener('mouseenter', this.onMouseEnter);
      this.section.removeEventListener('mouseleave', this.onMouseLeave);
      this.section.removeEventListener('focusin', this.onFocusIn);
      this.section.removeEventListener('focusout', this.onFocusOut);
      this.section.removeEventListener('keydown', this.onKeyDown);
    }
  }

  function initHero(section) {
    if (!section || instances.has(section)) return;
    instances.set(section, new VeiledHeroSlider(section));
  }

  function destroyHero(section) {
    const instance = instances.get(section);
    if (!instance) return;
    instance.destroy();
    instances.delete(section);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-veiled-hero]').forEach(initHero);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-veiled-hero]');
    destroyHero(section);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-veiled-hero]');
    const instance = instances.get(section);
    if (!instance) return;
    instance.showBlock(event.detail.blockId);
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const section = event.target.closest('[data-veiled-hero]');
    const instance = instances.get(section);
    if (!instance) return;
    instance.start();
  });
})();
